const ENV = process.env.REACT_APP_ENV || "DEV";
export { ENV };